import { Component, inject } from '@angular/core';
import { SiteConfigService } from '../core/site-config.service';
import { AymudoMarketingHubPage } from './aymudo-marketing-hub.page';
import { FortunePage } from './fortune.page';

@Component({
  selector:'app-aymudo-products-entry-page',
  imports:[AymudoMarketingHubPage,FortunePage],
  template:`@if(site.config().brandKey==='aymudo'){<app-aymudo-marketing-hub-page/>}@else{<app-fortune-page/>}`
})
export class AymudoProductsEntryPage{protected readonly site=inject(SiteConfigService)}
